module.exports = __webpack_public_path__ + "static/media/wifi_tethering.1866054a.svg";